// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '../public/js/flexible'
import './utils/rem'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../public/css/pubilc.css'
import '../src/iconfont/iconfont.css'
// import 'whatwg-fetch'
import jsCookie from 'js-cookie'
Vue.prototype.$cookie = jsCookie;
Vue.config.productionTip = false
Vue.use(ElementUI);

//防止重复点击
import preventReClick from './utils/preventRepeatClick';
Vue.use(preventReClick)

import store from './store/index';


// import VueTypedJs from 'vue-typed-js'
// Vue.use(VueTypedJs)

//导入工具集
import utils from './utils/utils'
Vue.prototype.utils = utils;

import 'babel-polyfill'
import 'event-source-polyfill'


//api
import api from "./api/api.js";
//axios拦截器
import axios from './api/interceptors'
//axios不支持vue.use()方式声明使用,在main.js申明Vue.prototype.axios=axios;那么在其他组件就可以this.axios调用使用
Vue.prototype.axios = axios;
Vue.prototype.api = api;







/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js